export const checkValidate = (email, password) => {
  const isEmailValid = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email);
  const isPasswordValid = /^[A-Za-z]\w{7,14}$/.test(password);

  if (!isEmailValid) return "Invalid Email Address";
  if (!isPasswordValid) return "Incorrect Password";

  return null;
};

export const addBasicDataValidation = (
  name,
  email,
  mobile,
  whatsapp,
  address,
  location,
  pincode,
  password
) => {
  const isNameValid = /^[a-zA-Z\s'-]{2,35}$/.test(name);
  const isValidAddress = /^[a-zA-Z0-9\s,'-./#]*$/.test(address);
  const isLocationValid = /^[a-zA-Z\s'-]{2,50}$/.test(location);
  const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email
  );
  const mobileNumberPattern = /^\d{10}$/.test(mobile);
  const isValidWhatsapp = /^\d{10}$/.test(whatsapp);

  const isValidPinCode = /^\d{6}$/.test(pincode);
  const isValidPassword =
    /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
      password
    );

  if (!isNameValid) return "Name should be 2-30 characters long";
  if (!isEmailValid) return "Invalid Email Address";
  if (!isLocationValid) return "Invalid Location";
  if (!isValidAddress) return "Invalid Address";
  if (!mobileNumberPattern) return "Invalid mobile number";
  if (!isValidWhatsapp) return "Invalid whatsapp number";
  if (!isValidPinCode) return "Invalid Pincode";
  if (!isValidPassword)
    return "Password must be at least 8 characters long and include at least one letter, one number, and one special character (@, $, !, %, *, ?, &).";
  return null;
};

export const addSocialDataValidation = (instagramProfile, youtubeLink) => {
  const isValidInstagramProfile =
    /\b(?:https?|ftp):\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b/.test(
      instagramProfile
    );

  const isValidYoutubeLink =
    /\b(?:https?|ftp):\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b/.test(
      youtubeLink
    );

  if (!isValidInstagramProfile) return "Invalid Instagram Profile Link";
  if (!isValidYoutubeLink) return "Invalid Youtube Channel Link";
  return null;
};

// export const addQuoteValidation = (
//   reel
// ) => {
//   const isNameValid = /^[a-zA-Z\s'-]{2,35}$/.test(name);
//   const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
//     email
//   );
//   const mobileNumberPattern = /^\d{10}$/.test(mobile);
//   const isValidWhatsapp = /^\d{10}$/.test(whatsapp);
//   const isValidInstagramProfile =
//     /\b(?:https?|ftp):\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b/.test(
//       instagramProfile
//     );

//   const isValidYoutubeLink =
//     /\b(?:https?|ftp):\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?\b/.test(
//       youtubeLink
//     );

//   const isValidPinCode = /\b[A-Z0-9]{1,10}\b/.test(pincode);

//   if (!isNameValid) return "Name should be 2-30 characters long";
//   if (!isValidInstagramProfile) return "Invalid Instagram Profile Link";
//   if (!isValidYoutubeLink) return "Invalid Youtube Channel Link";
//   if (!isEmailValid) return "Invalid Email Address";
//   if (!mobileNumberPattern) return "Invalid mobile number";
//   if (!isValidWhatsapp) return "Invalid whatsapp number";
//   if (!isValidPinCode) return "Invalid Pincode";
//   return null;
// };
